import $ from 'jquery';
import { $window, MIN_DELAY, TRANSITION } from '../variables/variables.js';
import { isScroll } from '../page/page.js';

function addDataTimeoutID( $loader, timeoutID ) {
	let timeoutIDs = $loader.data( 'timeoutIDs' ) || [];

	timeoutIDs.push( timeoutID );
	$loader.data( 'timeoutIDs', timeoutIDs );
}

// Фиксированный загрузчик
$( () => {
	const $sticky = $( '.loader_sticky' );

	if ( ! $sticky.length ) {
		return;
	}

	const $content = $( '.loader__content', $sticky );

	let fixedTop = $sticky.offset().top;
	let floorTop = fixedTop + $sticky.height() - $content.height() - 2 * $content.position().top;

	$window.on( 'resizeWidth', () => {
		$sticky.removeClass( 'loader_sticky_floor loader_sticky_fixed' );

		fixedTop = $sticky.offset().top;
		floorTop = fixedTop + $sticky.height() - $content.height() - 2 * $content.position().top;

		toggle();
	} );

	function toggle() {
		if ( ! isScroll ) {
			return;
		}

		const SCROLL_TOP = $window.scrollTop();

		if ( SCROLL_TOP <= fixedTop ) {
			$sticky.removeClass( 'loader_sticky_floor loader_sticky_fixed' );
		} else if ( fixedTop < SCROLL_TOP && SCROLL_TOP < floorTop ) {
			$sticky.addClass( 'loader_sticky_fixed' ).removeClass( 'loader_sticky_floor' );
		} else {
			$sticky.addClass( 'loader_sticky_floor' ).removeClass( 'loader_sticky_fixed' );
		}
	}
	toggle();
	$window.on( 'scroll', toggle );
} );

export default ( $parent, callback ) => {
	const $loader = $parent.find( '.loader' );

	let delay      = new Date().getTime();
	let timeoutIDs = $loader.data( 'timeoutIDs' ) || [];

	while( timeoutIDs.length ) {
		clearTimeout( timeoutIDs.shift() );
	}
	$loader.addClass( 'loader_animate' );

	const TIMEOUT_ID1 = setTimeout( () => {
		$loader.addClass( 'loader_active' );
	}, MIN_DELAY );

	addDataTimeoutID( $loader, TIMEOUT_ID1 );

	return function() {
		const callArguments = arguments;
		const MIN_DELAY     = 700;

		delay = MIN_DELAY - ( new Date().getTime() - delay );
		delay = Math.max( delay, 0 );

		const TIMEOUT_ID2 = setTimeout( () => {
			callback.apply( null, callArguments );
			$loader.removeClass( 'loader_animate' );

			const $loaderSticky  = $loader.filter( '.loader_sticky' );
			const $contentSticky = $loaderSticky.children();

			if ( $loaderSticky.height() < 2 * parseFloat( $contentSticky.css( 'top' ) ) ) {
				$loaderSticky.addClass( 'loader_sticky_disabled' );
			} else {
				$loaderSticky.removeClass( 'loader_sticky_disabled' );
			}

			let TIMEOUT_ID3 =setTimeout( () => {
				$loader.removeClass( 'loader_active' );
			}, TRANSITION + 1 );

			addDataTimeoutID( $loader, TIMEOUT_ID3 );
		}, delay );

		addDataTimeoutID( $loader, TIMEOUT_ID2 );
	};
};
